// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
   apiKey: "AIzaSyAzP5qW8Vpl_nBHVE8sM7oZnvAbue5spvg",
    authDomain: "firechat-4f469.firebaseapp.com",
    databaseURL: "https://firechat-4f469.firebaseio.com",
    projectId: "firechat-4f469",
    storageBucket: "firechat-4f469.appspot.com",
    messagingSenderId: "483473629172",
    appId: "1:483473629172:web:76f1316b181a4d22"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
